import docEditorServiceApi from "../services/doc-editor-service-api";
import docOperationServiceApi from "../services/doc-operation-api";
import docprofileServiceApi from "../services/docprofile-service";
import signsimpliServiceApi from "../services/signsimpli-orch-service";
import JobManagerService from "../services/job-manager-api";
import CreateUUID, {
  createCookie,
  deleteCookie,
  readCookie,
  PerquisiteBountyEnable,
  addSignatureTextFile,
  currentPortalCD,
  getPortalCD,
  createEmailShareRequest,
  createEmailShareDocument,
  createEmailData,
} from "./helpers";
import {
  AudioExtension,
  currentDomain,
  downloadCounter,
  FilesBlobPath,
  ImageExtension,
  jobCounter,
  PdfSimpliTopic,
  VideoExtension,
  //WelcomeDocumentBlobPath,
  getDocumentBlobPathConfig,
  getTenantId,
  getBlobUri,
  blobSignature,
} from "./general-config";
import {
  APP_INSIGHT_ERROR,
  BasePortalCD,
  CategoryName,
  compressAliases,
  DEFAULT_USER_GUID,
  DomainName,
  splitAliases,
  WELCOME_DOCUMENT_NAME,
  WELCOME_DOCUMENT_PATH_DIRECTORY,
} from "./constants";
import { DocOperationFileType, DocOperationType, EnvelopeStatus, SignerType } from "./../utils/enum-helper";
import dashboardOrchestrationServiceApi from "../services/dashboard-orchestration-service-api";
import userServiceApi from "../services/user-service-api";
import eventServiceApi from "../services/event-service-api";
import { DomainEnum } from "../services/enum/environment-enum";
import pdfsimpliController from "../services/pdfsimpli-controller";
import signsimpliController from "../services/signsimpli-controller";
import { processSignerFiles } from "./addmissingsignerfile";
import { GetEditorQueryInfo } from "../pages/sign-up/actions";
import { SeverityLevel } from "@microsoft/applicationinsights-web";

const getQueryParam = (qparams, param) => {
  const value = qparams.get(param);
  if (!value) return null;

  return param === "ofn" && value.includes(".com") ? value.replace(".com", ".pdf") : value;
};
const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
const createDocProfileRequestForWD = (userId, fileName) => {
  let sizeinKB = 1560;
  let dId = CreateUUID();
  let modifiedUserId = userId?.replace(/-/g, "");
  let fileUrl = getBlobFileNameWD(modifiedUserId, fileName);

  const docProfileData = {
    Id: dId,
    ModifiedDateTime: new Date().toISOString(),
    ModifieldFileUrl: fileUrl,
    ModifiedName: fileName,
    OriginalName: fileName,
    OrignialDocumentId: dId,
    OriginalFileFormat: ".pdf",
    SizeInKB: sizeinKB,
    OriginalFileUrl: fileUrl,
    RenderPdfFileUrl: fileUrl,
    ConvertedFileFormat: ".pdf",
    UploadDateTime: new Date().toISOString(),
    UniqueName: fileName,
    HasDocumentConverted: true,
    isForm: false,
    IsWelcomeDocument: true,
  };
  return docProfileData;
};
const createDocProfileRequest = async (qparams, userId, status, isPdfWzd, isWzd, requestedOperation) => {
  let sizeinKB = getQueryParam(qparams, "fskb");
  sizeinKB = !!sizeinKB ? sizeinKB : !!status ? "120" : "0";
  const convertFrom = getQueryParam(qparams, "frm");
  const originalfileName = getQueryParam(qparams, "ofn");
  const FirstPageUrl = getQueryParam(qparams, "fpu");
  let nonPDFFileUniqueName = getQueryParam(qparams, "npdf");
  const envelopeDocId = getQueryParam(qparams, "edid");
  const uniquefileName = getQueryParam(qparams, "unqn");

  let convertTo = getQueryParam(qparams, "to");

  if (splitAliases.includes(convertTo?.toLowerCase())) {
    convertTo = "split";
  } else if (compressAliases.includes(convertTo?.toLowerCase())) {
    convertTo = "compress";
  }
  const isFormQueryString = getQueryParam(qparams, "isForm");
  const edatabase = getQueryParam(qparams, "edatabase_click_id");

  const transcriptId = getQueryParam(qparams, "transcriptid");
  const speakerLabels = getQueryParam(qparams, "speakerlabels");
  const language = getQueryParam(qparams, "language");

  const speakersExpected = getQueryParam(qparams, "speakersexpected");
  const isTranscribePartial = getQueryParam(qparams, "istranscribepartial");

  const format = getQueryParam(qparams, "format");
  const chars = getQueryParam(qparams, "chars");
  const speakerMappingData = getQueryParam(qparams, "speakerMappingData");
  const isTranscribe = getQueryParam(qparams, "istranscribe");
  const transcriptJson = getQueryParam(qparams, "transcriptJson");
  const isForms =
    isFormQueryString !== null || edatabase !== null || convertTo?.toLowerCase().includes("wzd") ? true : false;
  if (
    convertTo?.toLowerCase() === "merge" ||
    (convertTo?.toLowerCase() === "pdf" && convertFrom?.toLowerCase() == "pdf")
  ) {
    nonPDFFileUniqueName = uniquefileName;
  }
  if (convertTo?.toLowerCase() === "text") {
    convertTo = "txt";
  }

  const getFileNamePart = (fileName, part) => {
    if (!!fileName) {
      const parts = fileName.trim().split(".");
      return part === "name" ? parts[0] : parts.pop();
    } else {
      return "";
    }
  };
  const getFileNamePartForWzd = (originalFileName, isPdfWzd) => {
    if (originalFileName.includes("_")) {
      return isPdfWzd
        ? originalFileName.split("_")[2]
        : originalFileName.split("_")[1].split(".")[0] + "." + originalFileName.split(".").pop();
    } else {
      return isPdfWzd
        ? originalFileName
        : originalFileName.split(".").slice(0, -1).join(".") + "." + originalFileName.split(".").pop();
    }
  };
  const renderPdfFileUrlConditionArr = ["pdf", "ppt", "pptx", "png", "doc", "docx", "jpg", "jpeg", "xls", "xlsx"];
  const textArr = ["text"];
  let dId = CreateUUID();
  let sourceLanguage = "";
  let targetLanguage = "";
  if (!!getQueryParam(qparams, "tf") && !!getQueryParam(qparams, "tt")) {
    sourceLanguage = getQueryParam(qparams, "tf");
    targetLanguage = getQueryParam(qparams, "tt");
  }

  const docProfileData = {
    Id: dId,
    OriginalName:
      convertFrom?.toLowerCase() === "html"
        ? `${getFileNamePart(originalfileName, "name", isPdfWzd, isWzd)}.pdf`
        : isPdfWzd || isWzd
          ? getFileNamePartForWzd(originalfileName, isPdfWzd)
          : originalfileName,
    FirstPageUrl: getBlobFileName(userId, !!FirstPageUrl && FirstPageUrl !== "null" ? FirstPageUrl : uniquefileName),
    DisplayName: isPdfWzd || isWzd ? getFileNamePartForWzd(originalfileName, isPdfWzd) : getQueryParam(qparams, "ofn"),
    UniqueName: uniquefileName,
    ModifiedName: uniquefileName?.trim(),
    SizeInKB: sizeinKB,
    OriginalFileUrl: getBlobFileName(
      userId,
      !!nonPDFFileUniqueName && nonPDFFileUniqueName !== "null" ? nonPDFFileUniqueName : uniquefileName,
    ),
    ModifieldFileUrl: getBlobFileName(
      userId,
      !!nonPDFFileUniqueName && nonPDFFileUniqueName !== "null" ? nonPDFFileUniqueName : uniquefileName,
    ),
    RenderPdfFileUrl:
      renderPdfFileUrlConditionArr.includes(convertTo?.toLowerCase()) ||
      textArr.includes(convertTo?.toLowerCase()) ||
      !originalfileName?.toLowerCase().includes("pdf") ||
      convertTo?.toLowerCase() === "merge" //todo - check for other languange from resource file in future
        ? getBlobFileName(userId, uniquefileName?.trim())
        : getBlobFileName(
            userId,
            !!nonPDFFileUniqueName && nonPDFFileUniqueName !== "null" ? nonPDFFileUniqueName : uniquefileName,
          ),
    PdfUrlWithAnnotation: "",
    ModifiedDateTime: new Date().toISOString(),
    UploadDateTime: new Date().toISOString(),
    OriginalFileFormat:
      convertFrom && convertFrom.toLowerCase() === "html"
        ? ".pdf"
        : convertTo?.toLowerCase().includes("pdfwzd")
          ? "pdfwzd"
          : convertTo?.toLowerCase() === "wzd"
            ? "wzd"
            : getFileNamePart(originalfileName, "ext"),
    ConvertedFileFormat: convertTo?.toLowerCase().includes("wzd") ? "pdf" : convertTo?.toLowerCase(),
    OrignialDocumentId: dId,
    IsWelcomeDocument: false,
    IsSignSimipliDoc: getQueryParam(qparams, "evp") === "true",
    IsAdvanceFormatDoc: getQueryParam(qparams, "isadvancefmt") === "true",
    CategoryName: !!status ? null : getCategoryName(originalfileName.split(".").pop().toLowerCase(), qparams),
    JobId: "",
    isForm: isForms,
    translateFrom: sourceLanguage,
    translateTo: targetLanguage,
    CustomProps: !!transcriptId
      ? {
          transcriptid: transcriptId,
          language: language,
          speakerlabels: !!speakerLabels ? speakerLabels : "false",
          speakersexpected: !!speakersExpected ? speakersExpected : "0",
          format: format ? format : "",
          chars: chars ? chars : "",
          speakerMappingData: speakerMappingData ? speakerMappingData : "",
          requestedOperation: requestedOperation ? requestedOperation : "",
          transcriptjson: !!transcriptJson ? transcriptJson : "",
        }
      : null,
    TenantId: getTenantId(),
    IsSecure: currentPortalCD() === BasePortalCD.PSSC ? true : false,
  };
  if (!!status) {
    const docProfileData = {
      Id: dId,
      fileName: uniquefileName,
      ModifiedDateTime: new Date().toISOString(),
      OrignialDocumentId: dId,
      OriginalName: uniquefileName,
      OriginalFileFormat: "pdf",
      UniqueName: uniquefileName,
      ModifiedName: uniquefileName?.trim(),
      PDFRender: uniquefileName?.trim(),
      UploadDateTime: new Date().toISOString(),
      SizeInKB: sizeinKB,
      FirstPageUrl: getBlobFileName(userId, !!FirstPageUrl && FirstPageUrl !== "null" ? FirstPageUrl : uniquefileName),
      OriginalFileUrl: getBlobFileName(
        userId,
        !!nonPDFFileUniqueName && nonPDFFileUniqueName !== "null" ? nonPDFFileUniqueName : uniquefileName,
      ),
      ModifieldFileUrl: getBlobFileName(
        userId,
        !!nonPDFFileUniqueName && nonPDFFileUniqueName !== "null" ? nonPDFFileUniqueName : uniquefileName,
      ),
      RenderPdfFileUrl:
        renderPdfFileUrlConditionArr.includes(convertTo?.toLowerCase()) ||
        textArr.includes(convertTo?.toLowerCase()) ||
        !originalfileName?.toLowerCase().includes("pdf") ||
        convertTo?.toLowerCase() === "merge" //todo - check for other languange from resource file in future
          ? getBlobFileName(userId, uniquefileName?.trim())
          : getBlobFileName(
              userId,
              !!nonPDFFileUniqueName && nonPDFFileUniqueName !== "null" ? nonPDFFileUniqueName : uniquefileName,
            ),
      ConvertedFileFormat: "pdf",
      HasDocumentConverted: false,
      isForm: false,
      IsWelcomeDocument: false,
      IsSignSimipliDoc: true,
      Status: status,
      TenantId: getTenantId(),
    };
    return docProfileData;
  }

  return docProfileData;
};

const UpdateDocProfileRequest = (docProfileData, JobId, jobStatus) => {
  docProfileData.jobId = JobId;
  let status = "";
  status = "inprogress";
  // if (jobStatus === 20) {
  //   status = "inprogress";
  // } else if (jobStatus === 30) {
  //   status = "completed";
  // }
  if (!docProfileData.customProps || Object.keys(docProfileData.customProps).length == 0) {
    docProfileData.customProps = { jobstatus: status };
  } else {
    docProfileData.customProps["jobstatus"] = status;
  }

  return docProfileData;
};

const getCategoryName = (ext, queryParams) => {
  let isTranslate = false;
  let isTranscribe = false;
  if (queryParams) {
    isTranslate = getQueryParam(queryParams, "istranslate") === "true" ? true : false;
    isTranscribe = getQueryParam(queryParams, "istranscribe") === "true" ? true : false;
  }

  let categoryName = "document";
  if (!!ext) {
    if (!!isTranslate && isTranslate) {
      categoryName = "translate";
    } else if (!!isTranscribe && isTranscribe) {
      categoryName = "transcription";
    } else if (AudioExtension.includes(ext.toUpperCase())) {
      categoryName = "audio";
    } else if (VideoExtension.includes(ext.toUpperCase())) {
      categoryName = "video";
    } else if (ImageExtension.includes(ext.toUpperCase())) {
      categoryName = "image";
    }
    return categoryName;
  } else {
    return categoryName;
  }
};
export const getDocOperationBlobData = (
  docProfileData,
  userId,
  isReplaceContainer,
  signerType,
  envelopeDocId,
  isWzd,
  requestedOperation,
  uniqueNameForLegalSimpli,
  queryData,
  queryParams,
) => {
  let docOperationBlobdata = {
    DocOperationID: CreateUUID(),
    FromFormat: isReplaceContainer ? DocOperationFileType.NONE : getFileTypeValue(docProfileData.OriginalFileFormat),
    ToFormat: isReplaceContainer ? DocOperationFileType.NONE : getFileTypeValue(docProfileData.ConvertedFileFormat),
    OperationType: getOperationTypeValue("REPLACE_CONTAINER"),
    BlobOutputFolder: userId.replaceAll("-", ""),
    ExistingBlobContainer: DEFAULT_USER_GUID.replaceAll("-", ""),
    FileNames: getListOfFileProduced(
      docProfileData,
      signerType,
      envelopeDocId,
      isWzd,
      requestedOperation,
      uniqueNameForLegalSimpli,
      queryData,
      queryParams,
    ),
    GeneralContext: {
      VisitId: readCookie("visitGuid"),
      VisitorId: readCookie("visitorGuid"),
      ABTestResult: null,
    },
  };
  return docOperationBlobdata;
};

const getDocOperationBlobDataWD = (docProfileDataWD, fileName, userId, isReplaceContainer) => {
  let docOperationBlobdata = {
    DocOperationID: CreateUUID(),
    FromFormat: isReplaceContainer ? DocOperationFileType.NONE : getFileTypeValue(docProfileDataWD.OriginalFileFormat),
    ToFormat: isReplaceContainer ? DocOperationFileType.NONE : getFileTypeValue(docProfileDataWD.ConvertedFileFormat),
    OperationType: getOperationTypeValue("REPLACE_CONTAINER"),
    BlobOutputFolder: userId.replaceAll("-", ""),
    ExistingBlobContainer: WELCOME_DOCUMENT_PATH_DIRECTORY.replaceAll("-", ""),
    FileNames: getListOfFileProducedWD(fileName),
    GeneralContext: {
      VisitId: readCookie("visitGuid"),
      VisitorId: readCookie("visitorGuid"),
      ABTestResult: null,
    },
  };
  return docOperationBlobdata;
};

const getDocOperationConvertRequest = (
  docProfileResponse,
  userId,
  targetXtn,
  sourceLanguage,
  targetLanguage,
  summarizationFile,
) => {
  var docProfileData = docProfileResponse.data;
  let filePath = docProfileData.modifieldFileUrl;
  let fromExt = docProfileData.originalFileFormat;
  if (!!docProfileData.pdfUrlWithAnnotation) {
    fromExt = "pdf";
    filePath = docProfileData.pdfUrlWithAnnotation;
  } else if (
    fromExt.toLowerCase() !== "pdf" &&
    targetXtn.toLowerCase() !== "pdf" &&
    !AudioExtension.includes(fromExt.toUpperCase()) &&
    !VideoExtension.includes(fromExt.toUpperCase())
  ) {
    fromExt = "pdf";
    filePath = docProfileData.renderPdfFileUrl;
  }
  // if (docProfileData.customProps && docProfileData.customProps["transcriptid"]) {
  //   fromExt = "none";
  // }
  var operation = "CONVERT";
  var responseFileName = "";
  var fileName = docProfileData.modifiedName;
  //For transcription and RequestResponse json file only
  if (summarizationFile) {
    fileName = responseFileName = summarizationFile?.replace(/\.json$/, "");
    fromExt = "url";
    targetXtn = "pdf";
    filePath = "";
  }
  var fromFormat = getFileTypeValue(fromExt);
  var toFormat = getFileTypeValue(targetXtn);
  var descendantFromFormat = "";
  var descendantToFormat = "";
  let generalCtx = {
    VisitId: readCookie("visitGuid"),
    VisitorId: readCookie("visitorGuid"),
    ABTestResult: null,
  };

  let convertRequest = {
    userId: userId,
    docId: docProfileData.id,
    fromType: fromExt?.toUpperCase(),
    toType: targetXtn?.toUpperCase(),
    itemType: "FILE",
    fileType: "",
    operationName: "CONVERT",
    CustumMetaData: null,
  };
  var isScannedFile = false;
  var customMetaData = null;
  if (docProfileData.convertedFileFormat.toLowerCase() === "split") {
    operation = "SPLIT";
  } else if (docProfileData.convertedFileFormat.toLowerCase() === "compress") {
    operation = "COMPRESS";
  } else if (docProfileData.customProps && docProfileData.customProps["transcriptid"]) {
    customMetaData = {
      transcriptid: docProfileData.customProps["transcriptid"],
    };
  } else if (!!sourceLanguage && !!targetLanguage) {
    if (targetXtn !== "pdf") {
      customMetaData = {
        convertDocRequestAfterTranslation: JSON.stringify(convertRequest),
      };
    }
    operation = "DOC_TRANSLATION";
    var abTestResult = readCookie("transocrvarientabval");
    if (abTestResult) {
      generalCtx = {
        VisitId: readCookie("visitGuid"),
        VisitorId: readCookie("visitorGuid"),
        ABTestResult: abTestResult,
      };
      if (abTestResult === ("2" || "3")) {
        if (readCookie("fpocrenabled") != null && readCookie("fpocrenabled") !== "") {
          isScannedFile = Boolean(readCookie("fpocrenabled"));
        }
        deleteCookie("fpocrenabled");
        deleteCookie("ocrenabled");
      }
    }
    fromFormat = toFormat = getFileTypeValue("none");
    if (
      !!docProfileData.pdfUrlWithAnnotation &&
      filePath.indexOf("temp_") > -1
      // && targetXtn !== "pdf"
    ) {
      descendantFromFormat = "pdf";
      descendantToFormat = "pdf";
      fileName = filePath.split("/").pop();
      responseFileName = fileName.substr(0, fileName.lastIndexOf(".")) + "_output_{NEW-DOC-OPID}";
    } else {
      descendantFromFormat = "PDF";
      descendantToFormat = "PDF";
      responseFileName =
        docProfileData.modifiedName.substr(0, docProfileData.modifiedName.lastIndexOf(".")) + "_output_{NEW-DOC-OPID}";
      filePath = docProfileData.renderPdfFileUrl;
    }
  }
  let docOperationRequest = {
    DocOperationID: CreateUUID(),
    FromFormat: fromFormat,
    ToFormat: toFormat,
    OperationType: getOperationTypeValue(operation),

    BlobOutputFolder: userId.replaceAll("-", ""),
    ExistingBlobContainer: DEFAULT_USER_GUID.replaceAll("-", ""),
    DocBlobPaths: summarizationFile ? null : [filePath],
    FileName: fileName,
    DocId: docProfileData.id,
    ResponseFileName: responseFileName,
    TranslateFrom: sourceLanguage,
    TranslateTo: targetLanguage,
    DescendantFromFormat: descendantFromFormat,
    DescendantToFormat: descendantToFormat,
    GeneralContext: generalCtx,
    isScannedFile: isScannedFile,
    CustomMetaData: customMetaData,
    URL: summarizationFile
      ? `${getBlobUri()}pdfsimpliusers/${userId.replaceAll("-", "")}/${summarizationFile?.replace(
          "json",
          "html",
        )}${blobSignature()}`
      : "",
  };

  return docOperationRequest;
};

export const ProcessSignInRequest = async (
  queryParams,
  userId,
  isPerquisiteBountyEnable,
  isSocialUser,
  isGuestUser,
  locale,
  isLoggedIn,
) => {
  let portalCD = getPortalCD();
  try {
    if (!queryParams) return;
    let envId = getQueryParam(queryParams, "evp");
    let envelopeDocId = getQueryParam(queryParams, "edid");
    let convertTo = getQueryParam(queryParams, "to");
    let isPdfWzd = convertTo === "pdfwzd";
    let isWzd = convertTo === "wzd";
    let prtlSrc = getQueryParam(queryParams, "prtlSrc")?.toLowerCase();

    let envelope = "";
    let statusEnum = "";
    let signerType = "";
    let status = "";
    const isTranscribe = getQueryParam(queryParams, "istranscribe");
    let requestedOperation = decodeURIComponent(getQueryParam(queryParams, "reqop"));
    let hasSummarization = false;
    let summarizationFile = "";
    if (requestedOperation && requestedOperation.toLowerCase() !== "null" && requestedOperation.trim() !== "") {
      hasSummarization = requestedOperation
        .split(",")
        .map((entry) => entry.split("~").map((p) => p.trim()))
        .some(([op, file]) => {
          if (
            op === "110" &&
            file &&
            file.toLowerCase() !== "blank" &&
            file.toLowerCase() !== "error" &&
            file.toLowerCase() !== "null" &&
            file.endsWith(".json")
          ) {
            summarizationFile = file;
            return true;
          }
          return false;
        });
    }
    let queryData = [];
    if (queryParams?.has("querydata")) {
      queryData = await fetchEditorInfo(queryParams);
    }
    if (!!envId) {
      envelope = await GetEnvelopeByEnvelopeId(envId);
      statusEnum = envelope?.status;
      signerType = envelope?.signerType;
      status = Object.keys(EnvelopeStatus).find((key) => EnvelopeStatus[key] === statusEnum);

      let uidCookie = !!readCookie("uid") ? readCookie("uid") : null;

      if (userId.replaceAll("-", "") !== uidCookie?.replaceAll("-", "")) {
        await UpdateExistingWithLoggedIn(envelope, envId, userId);
      }
    }

    let userProfileResponse = await userServiceApi.getUserProfile(userId);
    if (isSocialUser || isGuestUser) {
      let documentProfile = userProfileResponse.documentProfile || [];
      if (
        currentDomain() !== DomainEnum.PDFSIMPLI &&
        (documentProfile.length === 0 || !documentProfile.some((doc) => doc.isWelcomeDocument))
      ) {
        await addWelcomeDocument(userId);
      }
    }

    let docProfileData = {};
    let docProfileResponse = "";
    let docprofileId = "";
    if (!!queryData && queryData.length > 0) {
      docProfileData = CreateMultipleDocProfileRequest(queryParams);
      docProfileResponse = await CreateMultipleDocProfile(userId, docProfileData, true);
      docprofileId = docProfileResponse?.docInfo?.[0]?.id;
     try {
        if (isPerquisiteBountyEnable && docProfileData?.CategoryName === CategoryName.SHARE_SIMPLI) {
          await delay(2000);
          await dashboardOrchestrationServiceApi.sendShareEmails({ 
            userGuid: userId, 
            docGuid: docprofileId 
          });
        }
      } catch (error) {
        console.error("sendShareEmails failed:", error);
      }
    } else {
      docProfileData = await createDocProfileRequest(queryParams, userId, status, isPdfWzd, isWzd, requestedOperation);
      docProfileResponse = await CreateDocProfile(userId, docProfileData, true);
      docprofileId = docProfileResponse?.data?.id;
    }

    if (!docProfileResponse) return;

    let docOperationBlobdata = getDocOperationBlobData(
      docProfileData,
      userId,
      true,
      signerType,
      envelopeDocId,
      isWzd,
      requestedOperation,
      "",
      queryData,
      queryParams,
    );

    if (!!signerType) {
      await processSignerFiles(envelopeDocId, docProfileData);
    }

    await addSignatureTextFile();

    if (convertTo?.toLowerCase().includes("wzd")) {
      await AddWizardFiles(docProfileResponse);
    }
    // Step 1: Process document only if file does NOT exist
    let jobStatusResponse = {};
    const isPortalSource = prtlSrc?.startsWith("psmp") || prtlSrc?.startsWith("psop");
    if (!isLoggedIn || (readCookie("rwk") && readCookie("ptk")) || isPortalSource) {
      let operationResponse = await ProcessDocOperationRequest(docOperationBlobdata);
      if (!operationResponse) return;
      deleteCookie("saveWzdData");
      deleteCookie("rwk");
      deleteCookie("ptk");
      jobStatusResponse = await DocOperationJobStatusWithInterval(operationResponse.docId);
      console.log("jobStatusResponse ", jobStatusResponse);
      if (!jobStatusResponse) {
        console.log("RETURN AFTER NULL JOB MANAGER STATUS... ");
        return operationResponse;
      }
    }
    if (isTranscribe === "true") {
      await processDocumentForTranscription(docProfileData, queryParams, userId, requestedOperation);
    }
    if (envId) {
      let isVoided = readCookie("annot") === "voided";
      await UpdateEnvelopeDocument(queryParams, userId, docProfileData.Id, isVoided);
    }

    // Step 2: Common logic (runs whether file existed or not)
    let ProcessAnnotationResponse = await ProcessAnnotationBlob(
      docProfileData.Id,
      docProfileData.UniqueName,
      userId,
      docProfileData.CategoryName,
    );

    if (!ProcessAnnotationResponse) return;

    if (isPerquisiteBountyEnable || isGuestUser) {
      if (signerType === SignerType.MULTISIGNER) {
        await MultiSignerEnvelopeEvent(signerType, envId, userId);
      }

      let fL = readCookie("fl"); //finish later cookie from signer page
      if (fL !== "true" || fL == null) {
        if (!!envId) {
          await EnvelopeEvent(signerType, envId);
        }
      }
      if (!!readCookie("fl")) {
        deleteCookie("fl");
      }

      // Step 3: If doc needs conversion, go ahead
      if (ToBeProcessForConversion(queryParams, docProfileData, hasSummarization, queryData)) {
        const attachment = readCookie("attch");
        if (attachment) {
          await sendEmailAsAttachmentFromEditor(
            userId,
            docProfileResponse.data.id,
            locale,
            portalCD,
            attachment,
            docProfileData.OriginalFileFormat,
          );
          return ProcessAnnotationResponse;
        } else {
          let docOperationRequest = {};
          let convertOperationResponse = {};
          if (!!queryData && queryData.length > 0) {
            docOperationRequest = DocOperationRequestForTextToSpeech(docProfileResponse, userId, queryData);
            convertOperationResponse = await ProcessDocOperationRequest(docOperationRequest);
          } else {
            docOperationRequest = getDocOperationConvertRequest(
              docProfileResponse,
              userId,
              docProfileData.ConvertedFileFormat,
              getQueryParam(queryParams, "tf"),
              getQueryParam(queryParams, "tt"),
              summarizationFile,
            );
            convertOperationResponse = await ProcessDocOperationRequest(docOperationRequest);
          }
          if (!convertOperationResponse) return jobStatusResponse;

          let convertJobStatusResponse = await DasboardhOrchJobStatusWithInterval(
            convertOperationResponse.docId,
            docprofileId,
            "",
            "",
          );

          console.log("inside convertJobStatusResponse", convertJobStatusResponse);
          if (!convertJobStatusResponse) return convertOperationResponse;

          let dbDocProfileResponse = await GetDocProfile(userId, docprofileId);
          if (!!dbDocProfileResponse) {
            let updateDocProfileRq = UpdateDocProfileRequest(
              dbDocProfileResponse,
              convertJobStatusResponse.JobEntity.JobID,
              convertJobStatusResponse.JobEntity.Status,
            );
            console.log("updateDocProfileRq ", updateDocProfileRq);
            let docProfileUpdateresposne = await UpdateDocProfile(userId, updateDocProfileRq);
            console.log("docProfileUpdateresposne ", docProfileUpdateresposne);

            if (!docProfileUpdateresposne) console.log("Unable to update docProfile");
          } else {
            console.log("No ReEsponse DocProfile..");
          }
          return convertJobStatusResponse;
        }
      }
      return jobStatusResponse;
    } else {
      console.log("Unpaid User.. redirect user to plan page");
      return ProcessAnnotationResponse;
    }
  } catch (error) {
    console.error("Error processing sign-in request:", error);
  }
};

export const ProcessSignUpRequest = async (queryParams, userId, isPerquisiteBountyEnable) => {
  try {
    if (!!queryParams) {
      let envId = getQueryParam(queryParams, "evp");
      let envelopeDocId = getQueryParam(queryParams, "edid");
      let statusEnum = "";
      let signerType = "";
      let status = "";
      let envelope = "";
      let convertTo = getQueryParam(queryParams, "to");
      let isPdfWzd = convertTo === "pdfwzd";
      let isWzd = convertTo === "wzd";
      const isTranscribe = getQueryParam(queryParams, "istranscribe");
      let requestedOperation = decodeURIComponent(getQueryParam(queryParams, "reqop"));
      let hasSummarization = false;
      let summarizationFile = "";
      if (requestedOperation && requestedOperation.toLowerCase() !== "null" && requestedOperation.trim() !== "") {
        hasSummarization = requestedOperation
          .split(",")
          .map((entry) => entry.split("~").map((p) => p.trim()))
          .some(([op, file]) => {
            if (
              op === "110" &&
              file &&
              file.toLowerCase() !== "blank" &&
              file.toLowerCase() !== "error" &&
              file.toLowerCase() !== "null" &&
              file.endsWith(".json")
            ) {
              summarizationFile = file;
              return true;
            }
            return false;
          });
      }
      if (!!envId) {
        console.log("envelopeID", envId);
        envelope = await GetEnvelopeByEnvelopeId(envId);
        console.log("envelope", envelope);
        statusEnum = envelope?.status;
        signerType = envelope?.signerType;
        status = Object.keys(EnvelopeStatus).find((key) => EnvelopeStatus[key] === statusEnum);
        let uidCookie = readCookie("uid");
        if (userId.replaceAll("-", "") !== uidCookie.replaceAll("-", "")) {
          await UpdateExistingWithLoggedIn(envelope, envId, userId);
        }
      }
      let userProfileResponse = await userServiceApi.getUserProfile(userId);
      let documentProfile = userProfileResponse.documentProfile || [];

      //|| currentDomain() === DomainEnum.SIGNSIMPLI
      if (
        currentDomain() === DomainEnum.SIGNSIMPLI &&
        (documentProfile.length === 0 || !documentProfile.some((doc) => doc.isWelcomeDocument))
      ) {
        await addWelcomeDocument(userId);
      }

      let docProfileData = {};
      let docProfileResponse = "";
      let docprofileId = "";
      let queryData = [];
      if (queryParams?.has("querydata")) {
        queryData = await fetchEditorInfo(queryParams);
      }
      if (!!queryData && queryData.length > 0) {
        docProfileData = CreateMultipleDocProfileRequest(queryParams);
        docProfileResponse = await CreateMultipleDocProfile(userId, docProfileData, true);
        docprofileId = docProfileResponse?.docInfo?.[0]?.id;
       try {
          if (isPerquisiteBountyEnable && docProfileData?.CategoryName === CategoryName.SHARE_SIMPLI) {
            await delay(2000);
            await dashboardOrchestrationServiceApi.sendShareEmails({ 
              userGuid: userId, 
              docGuid: docprofileId 
            });
          }
        }catch (error) {
          console.error("sendShareEmails failed:", error);
        }
      } else {
        docProfileData = await createDocProfileRequest(
          queryParams,
          userId,
          status,
          isPdfWzd,
          isWzd,
          requestedOperation,
        );
        docProfileResponse = await CreateDocProfile(userId, docProfileData, true);
        docprofileId = docProfileResponse?.data?.id;
      }
      if (!!docProfileResponse) {
        const docOperationBlobdata = getDocOperationBlobData(
          docProfileData,
          userId,
          true,
          signerType,
          envelopeDocId,
          isWzd,
          requestedOperation,
          "",
          queryData,
          queryParams,
        );
        const operationResponse = await ProcessDocOperationRequest(docOperationBlobdata);
        await addSignatureTextFile();
        if (convertTo?.toLowerCase().includes("wzd")) {
          try {
            await AddWizardFiles(docProfileResponse);
          } catch (error) {
            console.error("Error in AddWizardFiles:", error);
          }
        }
        if (isTranscribe === "true") {
          await processDocumentForTranscription(docProfileData, queryParams, userId, requestedOperation);
        }
        if (!!operationResponse) {
          if (!!envId) {
            let isVoided = readCookie("annot") === "voided";
            await UpdateEnvelopeDocument(queryParams, userId, docProfileData.Id, isVoided);
          }
          let jobStatusResponse = await DocOperationJobStatusWithInterval(operationResponse.docId);
          if (!!jobStatusResponse) {
            let ProcessAnnotationResponse = await ProcessAnnotationBlob(
              docProfileData.Id,
              docProfileData.UniqueName,
              userId,
              docProfileData.CategoryName,
            );
            if (!!ProcessAnnotationResponse) {
              if (isPerquisiteBountyEnable === true) {
                let fL = readCookie("fl"); //finish later cookie from signer page
                if (fL !== "true" || fL == null) {
                  if (!!envId) {
                    await EnvelopeEvent(signerType, envId);
                  }
                }
                if (!!readCookie("fl")) {
                  deleteCookie("fl");
                }
                //ONLY IF PREMIUM. ProcessDocForConversion and again DocOperationJobStatus ..
                if (ToBeProcessForConversion(queryParams, docProfileData, hasSummarization)) {
                  let docOperationRequest = {};
                  let convertOperationResponse = {};
                  if (!!queryData && queryData.length > 0) {
                    docOperationRequest = DocOperationRequestForTextToSpeech(docProfileResponse, userId, queryData);
                    convertOperationResponse = await ProcessDocOperationRequest(docOperationRequest);
                  } else {
                    docOperationRequest = getDocOperationConvertRequest(
                      docProfileResponse,
                      userId,
                      docProfileData.ConvertedFileFormat,
                      getQueryParam(queryParams, "tf"),
                      getQueryParam(queryParams, "tt"),
                      summarizationFile,
                    );
                    convertOperationResponse = await ProcessDocOperationRequest(docOperationRequest);
                  }
                  if (!!convertOperationResponse) {
                    let convertJobStatusResponse = await DasboardhOrchJobStatusWithInterval(
                      convertOperationResponse.docId,
                      docprofileId,
                      "",
                      "",
                    );
                    console.log("inside convertJobStatusResponse", convertJobStatusResponse);
                    if (!!convertJobStatusResponse) {
                      // TO DO :: doc profile Get and Update...
                      let dbDocProfileResponse = await GetDocProfile(userId, docprofileId);
                      if (!!dbDocProfileResponse) {
                        console.log("inside docProfile");
                        // Update dbDocProfile data with job Id and Status
                        let updateDocProfileRq = UpdateDocProfileRequest(
                          dbDocProfileResponse,
                          convertJobStatusResponse.JobEntity.JobID,
                          convertJobStatusResponse.JobEntity.Status,
                        );
                        console.log("updateDocProfileRq ", updateDocProfileRq);
                        var docProfileUpdateresposne = await UpdateDocProfile(userId, updateDocProfileRq);
                        console.log("docProfileUpdateresposne ", docProfileUpdateresposne);
                        if (!!docProfileUpdateresposne) {
                        } else {
                          console.log("unbale to upate docProfile");
                        }
                      } else {
                        console.log("No ReEsponse DocProfile..");
                      }
                      return convertJobStatusResponse;
                    } else {
                      console.log("RETURN AFTER PROCESS DOC OPERATION...");
                      return convertOperationResponse;
                    }
                  } else {
                    console.log("RETURN AFTER BLOB PROCESS..");
                    return jobStatusResponse;
                  }
                } else {
                  return jobStatusResponse;
                }
              } else {
                return jobStatusResponse;
              }
            }
          } else {
            console.log("RETURN AFTER NULL JOB MANAGER STATUS... ");
            return operationResponse;
          }
        }
      }
    }
  } catch (error) {
    console.error("Error processing sign-up request:", error);
  }
};

export const UpdateExistingWithLoggedIn = async (envelope, evpId, loggedInUserId) => {
  createCookie("uid", loggedInUserId, 1);
  deleteCookie("seml");
  envelope.createdBy = loggedInUserId;
  await signsimpliServiceApi.updateEnvelope(envelope);
  let envDocument = await signsimpliServiceApi.getEnvelopeDocument(evpId);

  envDocument.forEach(async (doc) => {
    doc.createdBy = loggedInUserId;
    await signsimpliServiceApi.updateEnvelopDocument(doc);
  });
};

export const GetEnvelopeByEnvelopeId = async (envId) => {
  try {
    console.log("GetEnvelopeByEnvelopeId.envelopeID", envId);
    const Envelope = await signsimpliServiceApi.getEnvelopByEnvelopId(envId);
    // const status = signSimpliResponse.status;
    // let statusNo = Object.keys(EnvelopeStatus).find((key) => EnvelopeStatus[key] === status);
    return Envelope || null;
  } catch (error) {
    console.error("Error getting sign simpli response:", error);
    return null;
  }
};
export const UpdateDocument = async (userGuid, data) => {
  const url = await userServiceApi.addSingleDocumentIntoDocProfile(userGuid, data);
  return url;
};
export const UpdateEnvelopeDocument = async (qparams, userGuid, Id, isVoided) => {
  try {
    let envelopeDocId = getQueryParam(qparams, "edid");
    const envelopeDocument = await signsimpliServiceApi.getEnvelopDocumentByEnvelopeDocId(envelopeDocId);
    if (!isVoided) {
      envelopeDocument.signedDocumentPath = userGuid?.replaceAll("-", "") + "/" + envelopeDocId + ".json";
    }
    envelopeDocument.documentId = Id;
    await signsimpliServiceApi.updateEnvelopDocument(envelopeDocument);

    return envelopeDocument || null;
  } catch (error) {
    console.error("Error getting sign simpli response:", error);
    return null;
  }
};

export const CreateDocProfile = async (userId, docProfileData, isnewsetup) => {
  try {
    const docProfileResponse = await docprofileServiceApi.createDocProfile(userId, docProfileData, isnewsetup);
    return docProfileResponse || null;
  } catch (error) {
    console.error("Error creating doc profile:", error);
    return null;
  }
};

export const CreateMultipleDocProfile = async (userId, docProfileData, isnewsetup) => {
  try {
    const docProfileResponse = await docprofileServiceApi.createMultipleDocProfile(userId, docProfileData, isnewsetup);
    return docProfileResponse || null;
  } catch (error) {
    console.error("Error creating doc profile:", error);
    return null;
  }
};

export const GetDocProfile = async (userId, docId, isnewsetup) => {
  try {
    const docProfileResponse = await docprofileServiceApi.GetDocProfile(userId, docId);
    return docProfileResponse || null;
  } catch (error) {
    console.error("Error While get doc profile:", error);
    return null;
  }
};

export const UpdateDocProfile = async (userId, docProfile) => {
  try {
    const docProfileResponse = await docprofileServiceApi.UpdateDocProfile(userId, docProfile);
    return docProfileResponse || null;
  } catch (error) {
    console.error("Error While get doc profile:", error);
    return null;
  }
};

export const ProcessAnnotationBlob = async (docID, documentName, userGuid, docCategory) => {
  try {
    const annotationData = {
      DocId: docID,
      DocUniqueName: documentName,
      UserGuid: userGuid,
      DocCategory: docCategory,
    };
    const response = await docEditorServiceApi.ProcessAnnotationsBlob(annotationData);
    return response;
  } catch (error) {
    return null;
  }
};

export const ProcessDocOperationRequest = async (docOperationRequest) => {
  try {
    const operationResponse = await docOperationServiceApi.docOperationPost(docOperationRequest);
    if (operationResponse && operationResponse.isRequestSubmitted) {
      return operationResponse;
    } else {
      return null;
    }
  } catch (error) {
    return null;
  }
};

export const DocOperationJobStatusWithInterval = async (jobId) => {
  let timer = 0;
  return new Promise((resolve, reject) => {
    const interval = setInterval(async () => {
      try {
        timer += 1;
        const responseStatus = await getDocOperationJobStatus(jobId);

        if (responseStatus && responseStatus.status === 30) {
          clearInterval(interval);
          resolve(responseStatus);
        } else if (responseStatus && (responseStatus.status === 40 || !responseStatus)) {
          clearInterval(interval);
          reject(new Error("Job status indicates failure or undefined."));
        } else if (timer === jobCounter) {
          clearInterval(interval);
          reject(new Error("Job status check timed out."));
        }
      } catch (error) {
        clearInterval(interval);
        reject(error);
      }
    }, 2000);
  });
};

export const DasboardhOrchJobStatusWithInterval = async (jobId, docId, itemType = "", fileType = "") => {
  let timer = 0;
  return new Promise((resolve, reject) => {
    const interval = setInterval(async () => {
      try {
        timer += 1;
        const responseStatus = await getDashboardOrchJobStatus(jobId, docId, itemType, fileType);
        if (!!responseStatus) {
          if (responseStatus && responseStatus.JobEntity.Status === 30) {
            clearInterval(interval);
            resolve(responseStatus);
          } else if (responseStatus && responseStatus.JobEntity.Status === 20) {
            console.log(responseStatus);
            console.log("Status In Progess...");
            clearInterval(interval);
            resolve(responseStatus);
          } else if (responseStatus && (responseStatus.JobEntity.Status === 40 || !responseStatus)) {
            clearInterval(interval);
            reject(new Error("Dashboard Job status indicates failure or undefined."));
          } else if (timer === jobCounter) {
            clearInterval(interval);
            if (responseStatus && responseStatus.JobEntity.Status === 10) {
              resolve(responseStatus);
            } else {
              reject(new Error("Dashboard Job status check timed out."));
            }
          }
        } else {
          clearInterval(interval);
          reject(new Error("unable to get Dashboard Job status."));
        }
      } catch (error) {
        clearInterval(interval);
        reject(error);
      }
    }, 2000);
  });
};

const getDocOperationJobStatus = async (jobId) => {
  try {
    const jobStatus = await JobManagerService.getJobStatus(jobId);

    if (jobStatus && jobStatus.jobID) {
      return jobStatus;
    }
    return null;
  } catch (error) {
    console.error("Error getting job status:", error);
    return null;
  }
};

const getDashboardOrchJobStatus = async (jobId, docId, itemTpe = "", filetype = "") => {
  try {
    const jobStatus = await dashboardOrchestrationServiceApi.CompleteProcessDocument(jobId, docId, itemTpe, filetype);
    //if (jobStatus && jobStatus.jobID) {
    return jobStatus;
    //}
  } catch (error) {
    console.error("Error getting job status:", error);
    return null;
  }
};

const ToBeProcessForConversion = (queryParams, docProfileData, hasSummarization, queryData) => {
  if (hasSummarization) return true;

  if (queryParams?.has("querydata")) {
    const original = queryData?.[0]?.OriginalFileFormat?.toLowerCase();
    const converted = queryData?.[0]?.ConvertedFileFormat?.toLowerCase();

    if (original && converted) {
      return original !== converted;
    }

    return false;
  }

  if (getQueryParam(queryParams, "istranslate") === "true") return true;

  if (getQueryParam(queryParams, "istranscribe") === "true") return false;

  const category = docProfileData?.categoryName?.toLowerCase();
  const originalFormat = docProfileData?.OriginalFileFormat?.toUpperCase();
  const convertedFormat = docProfileData?.ConvertedFileFormat?.toUpperCase();

  const blockedCategories = new Set([
    "image-ai",
    "writesimpli-summarizer-ai",
    "writesimpli-detector-ai",
    "writesimpli-plagiarism-ai",
    "writesimpli-citations-ai",
    "writesimpli-grammar-ai",
    "writesimpli-compare-ai",
  ]);

  if (blockedCategories.has(category)) return false;

  if (category === "image") {
    return convertedFormat === "PDF" || convertedFormat === ".PDF";
  }

  if (AudioExtension.includes(originalFormat)) return false;

  if (VideoExtension.includes(originalFormat)) return false;

  if (docProfileData?.ConvertedFileFormat !== docProfileData?.OriginalFileFormat) return true;

  return false;
};

const getFileTypeValue = (fileType) => {
  if (
    !fileType ||
    fileType === "split" ||
    fileType === "merge" ||
    fileType === "compress" ||
    fileType === "wzd" ||
    fileType === "pdfwzd" ||
    fileType === "edit"
  ) {
    fileType = "pdf";
  }
  const value = DocOperationFileType[fileType.toUpperCase()];
  if (value !== undefined) {
    return parseInt(value, 10);
  }
  throw new Error(`File type ${fileType} not found in DocOperationFileType`);
};

const getOperationTypeValue = (operationValue) => {
  const value = DocOperationType[operationValue.toUpperCase()];
  if (value !== undefined) {
    return parseInt(value, 10);
  }
  throw new Error(`File type ${operationValue} not found in DocOperationType`);
};
export const getFileNameFromUrl = (blobUrl) => {
  let result = blobUrl?.substring(blobUrl?.lastIndexOf("/") + 1);
  result = result?.split("?")[0];
  return result;
};

const getFinalFileName = (uniqueName, modifiedName, newFileName = "", extension = "") => {
  const getFileNameWithoutExtension = (name) => {
    const lastDotIndex = name?.lastIndexOf(".");
    return lastDotIndex === -1 ? name : name?.substring(0, lastDotIndex);
  };

  if (newFileName === "") {
    newFileName = getFileNameWithoutExtension(uniqueName);
  }
  if (extension === "") {
    extension = modifiedName ? modifiedName?.split(".")?.pop() : uniqueName?.split(".")?.pop();
  }
  return getFileNameWithoutExtension(newFileName) + "." + extension;
};

const getListOfFileProduced = (
  newDocumentProfile,
  signerType,
  envelopeDocId,
  isWzd,
  requestedOperation,
  uniqueNameForLegalSimpli,
  queryData,
  queryParams,
) => {
  let foln = newDocumentProfile.UniqueName;
  let templateName = "";
  if (!isWzd) {
    if (foln?.indexOf("_") > -1) {
      templateName = foln?.split("_")[2];
    } else {
      templateName = foln;
    }
  }
  let fileNames = [];
  fileNames = getListForPortals(
    newDocumentProfile,
    uniqueNameForLegalSimpli,
    queryData,
    fileNames,
    signerType,
    envelopeDocId,
    templateName,
    requestedOperation,
    queryParams,
  );
  if (!!templateName) {
    fileNames?.push(templateName);
  }
  var fileNamesArray = fileNames.filter((value, index, self) => self?.indexOf(value) === index);

  return fileNamesArray;
};
const getBlobFileName = (userGuid, fileName) => {
  return `${FilesBlobPath()}/${userGuid.replaceAll("-", "")}/${fileName}`;
};
const getListOfFileProducedWD = (fileName) => {
  let fileNames = [fileName];
  return fileNames;
};
const getBlobFileNameWD = (userGuid, fileName) => {
  let blobPathConfig = getDocumentBlobPathConfig();
  let welcomeDocumentPath = blobPathConfig.WelcomeDocumentPDFSimpli;

  if (currentDomain() === DomainEnum.SIGNSIMPLI) welcomeDocumentPath = blobPathConfig.WelcomeDocumentSignSimpli;

  return `${welcomeDocumentPath.replaceAll(WELCOME_DOCUMENT_PATH_DIRECTORY, userGuid)}`;
};

//ToDO: ANalyze if this can be made generic for all portal
export const addWelcomeDocument = async (userId) => {
  let docPrefix = currentDomain();
  if (docPrefix == DomainEnum.PDFSIMPLI) docPrefix = "PDFSimpli";
  else if (docPrefix == DomainEnum.SIGNSIMPLI) docPrefix = "SignSimpli";
  else if (docPrefix == DomainEnum.LEGALSIMPLI) docPrefix = "LegalSimpli";
  console.log("inside addWelcomeDocument");
  let fileName = WELCOME_DOCUMENT_NAME.replace("##", docPrefix);
  let docProfileDataForWD = createDocProfileRequestForWD(userId, fileName);
  let docProfileResponseWD = await CreateDocProfile(userId, docProfileDataForWD, true);
  const docOperationBlobdataWD = getDocOperationBlobDataWD(docProfileResponseWD, fileName, userId, true);
  await ProcessDocOperationRequest(docOperationBlobdataWD);
};
const AddWizardFiles = async (docProfileResponse) => {
  let wizardData = {
    newDocProfileId: docProfileResponse.data.id,
    key: readCookie("rwk"),
    date: readCookie("ptk"),
    saveWzdData: readCookie("saveWzdData"),
  };

  let data = {
    newDocProfileId: docProfileResponse.data.id,
    rowKey: readCookie("rwk"),
    partitionKey: readCookie("ptk"),
    saveWzdData: readCookie("saveWzdData"),
  };
  if (currentDomain() === DomainEnum.SIGNSIMPLI) {
    const response = await signsimpliController.addWizard(data);
    if (!!response) {
      console.log("response", response);
      deleteCookie("saveWzdData");
    }
  } else {
    const response = await docEditorServiceApi.AddWizard(wizardData);
    if (!!response) {
      console.log("response", response);
    }
  }
};

export const EnvelopeEvent = async (signerType, envId) => {
  if (signerType === SignerType.SINGLESIGNER) {
    try {
      const data = {
        id: envId,
        content: null,
        metadata: null,
        userId: "00000000-0000-0000-0000-000000000000",
      };
      await eventServiceApi.postDataToEventService(data, "Envelope", "Envelope_Begin", PdfSimpliTopic());
    } catch (error) {
      console.error("Error posting event:", error);
      return null;
    }
  }
};
export const MultiSignerEnvelopeEvent = async (signerType, envId) => {
  if (signerType === SignerType.MULTISIGNER) {
    try {
      const data = {
        id: envId,
      };
      console.log("Posting multi signer envelop event:", data);
      await eventServiceApi.postDataToEventService(data, "Envelope", "Envelope_Begin", PdfSimpliTopic());
      console.log("Posted multi signer envelop event:");
    } catch (error) {
      console.error("Error posting event:", error);
      return null;
    }
  }
};

const sendEmailAsAttachmentFromEditor = async (
  userId,
  newDocumentProfileId,
  locale,
  portalCD,
  cookieValues,
  originalFormat,
) => {
  const emailValues = JSON.parse(decodeURIComponent(cookieValues));
  deleteCookie("attch");

  let finalRequest = createEmailShareRequest(
    userId,
    createEmailShareDocument(newDocumentProfileId, "FILE", "pdf", originalFormat),
    createEmailData(
      decodeURIComponent(emailValues.t),
      decodeURIComponent(emailValues.f),
      null,
      null,
      emailValues.s,
      emailValues.m,
    ),
    true,
    locale,
    portalCD,
    "false",
    emailValues.n,
  );

  await dashboardOrchestrationServiceApi.shareOrEmailDocuments(finalRequest);
};

const processDocumentForTranscription = async (docProfileData, queryParams, userId, requestedOperation) => {
  const transcriptId = getQueryParam(queryParams, "transcriptid");
  const format = getQueryParam(queryParams, "format");
  const chars = getQueryParam(queryParams, "chars");
  const speakerMappingData = getQueryParam(queryParams, "speakerMappingData");
  let data = {
    transcriptionDownloadRequest: {
      transcriptId: transcriptId,
      format: format,
      characters: chars,
      userGuid: userId,
      fileName: docProfileData?.UniqueName,
      documentId: docProfileData?.Id,
      speakerMappingData: speakerMappingData,
    },
    documentName: docProfileData?.OriginalName.replace(/\.[^/.]+$/, ""),
    requestedOperation: requestedOperation,
  };
  await dashboardOrchestrationServiceApi.getPdfUrlZip(data);
};

const fetchEditorInfo = async (queryParams) => {
  try {
    if (queryParams.has("querydata")) {
      const editorInfo = await GetEditorQueryInfo(queryParams.get("querydata"));

      const parsed = JSON.parse(editorInfo?.queryData);
      return parsed;
    }
  } catch (err) {
    console.error("Failed to fetch editor info:", err);
  }
};

const CreateMultipleDocProfileRequest = (qparams) => {
  const queryDataParam = getQueryParam(qparams, "querydata");
  const now = new Date();
  const folderPath =
    `${String(now.getMonth() + 1).padStart(2, "0")}_` +
    `${String(now.getDate()).padStart(2, "0")}_` +
    `${String(now.getFullYear()).slice(-2)}-` +
    `${String(now.getHours()).padStart(2, "0")}:` +
    `${String(now.getMinutes()).padStart(2, "0")}`;
  let docProfileData = {
    queryData: queryDataParam,
    tenantId: getTenantId(),
    folderPath: folderPath,
    UploadDateTime: new Date().toISOString(),
    ModifiedDateTime: new Date().toISOString(),
    CategoryName: getQueryParam(qparams, "cname"),
  };
  return docProfileData;
};

const getListForPortals = (
  newDocumentProfile,
  uniqueNameForLegalSimpli,
  queryData,
  fileNames,
  signerType,
  envelopeDocId,
  templateName,
  requestedOperation,
  queryParams,
) => {
  if (!!uniqueNameForLegalSimpli) {
    fileNames = getFileListForLegalSimpli(uniqueNameForLegalSimpli);
  } else if (Array.isArray(queryData) && queryData.length > 0) {
    fileNames = getFileListForImageGeneration(queryData, queryParams);
  } else if (!!signerType) {
    fileNames = getFileListForSignerFlow(newDocumentProfile, signerType, envelopeDocId, templateName);
  } else {
    fileNames = getFileListForPdfSimpli(newDocumentProfile, requestedOperation);
  }
  return fileNames;
};

const getFileListForLegalSimpli = (uniqueNameForLegalSimpli) => {
  let fileNames = [uniqueNameForLegalSimpli];
  return fileNames;
};

const getFileListForImageGeneration = (queryData, qparams) => {
  let queryDataCName = getQueryParam(qparams, "cname");
  if (queryDataCName.includes(CategoryName.WRITE_SIMPLI) || queryDataCName.includes(CategoryName.SHARE_SIMPLI)) {
    let fileNames = [];

    for (const item of queryData) {
      console.log(item);
      fileNames?.push(item.url?.substring(item.url?.lastIndexOf("/") + 1));
      fileNames?.push(item.previewUrl?.substring(item.previewUrl?.lastIndexOf("/") + 1));
    }
    return fileNames;
  } else if (queryDataCName.includes(CategoryName.TEXT_TO_SPEECH)) {
    let fileNames = [];

    for (const item of queryData) {
      const fileName = item?.url?.split("?")[0].split("/").pop();
      if (fileName) {
        fileNames?.push(fileName);
        fileNames?.push(fileName.replace(/\.[^/.]+$/, ".json"));
      }
      const previewFileName = item?.previewUrl?.split("?")[0].split("/").pop();
      if (previewFileName) {
        fileNames?.push(previewFileName);
      }
    }
    return fileNames;
  } else {
    let fileNames = queryData.map((item) => {
      const cleanUrl = getBlobUri() + "pdfsimpliusers/" + item?.url;
      return cleanUrl?.substring(cleanUrl.lastIndexOf("/") + 1);
    });
    return fileNames;
  }
};

const getFileListForSignerFlow = (newDocumentProfile, signerType, envelopeDocId, templateName) => {
  let fileNames = [
    signerType === SignerType.SINGLESIGNER ? "annotations_" + envelopeDocId + ".json" : null,
    envelopeDocId + ".json",
    "signed_" + envelopeDocId + ".pdf",
    "temp_" + newDocumentProfile.UniqueName,
    newDocumentProfile.UniqueName,
    getFileNameFromUrl(newDocumentProfile?.FirstPageUrl),
    getFileNameFromUrl(newDocumentProfile.OriginalFileUrl),
    getFileNameFromUrl(newDocumentProfile.RenderPdfFileUrl),
    getFinalFileName(
      newDocumentProfile.OriginalName ? newDocumentProfile.OriginalName : newDocumentProfile.UniqueName,
      newDocumentProfile.ModifiedName,
      newDocumentProfile.ModifiedName,
    ),
  ];
  if (!!templateName) {
    fileNames?.push(templateName);
  }
  return fileNames;
};

const getFileListForPdfSimpli = (newDocumentProfile, requestedOperation) => {
  let fileNames = [
    "temp_" + newDocumentProfile.UniqueName,
    newDocumentProfile.UniqueName,
    getFileNameFromUrl(newDocumentProfile?.FirstPageUrl),
    getFileNameFromUrl(newDocumentProfile.OriginalFileUrl),
    getFileNameFromUrl(newDocumentProfile.RenderPdfFileUrl),
    getFinalFileName(
      newDocumentProfile.OriginalName ? newDocumentProfile.OriginalName : newDocumentProfile.UniqueName,
      newDocumentProfile.ModifiedName,
      newDocumentProfile.ModifiedName,
    ),
    newDocumentProfile?.CustomProps?.transcriptjson,
    ...(requestedOperation
      ? (() => {
          let entries = requestedOperation.split(/[,%]/).map((e) => e.trim());
          let result = [];
          entries.forEach((entry) => {
            let [op, file] = entry.split("~").map((s) => s.trim());
            if (!file || ["blank", "error", "null"].includes(file.toLowerCase())) {
              return;
            }
            if (op === "110" && file.endsWith(".json")) {
              result.push(file);
              result.push(file.replace(/\.json$/, ".html"));
            } else {
              result.push(file);
            }
          });
          return result;
        })()
      : []),
  ];
  return fileNames;
};

const DocOperationRequestForTextToSpeech = (docProfileResponse, userId, queryData) => {
  var fromFormat = getFileTypeValue(queryData?.[0]?.OriginalFileFormat);
  var toFormat = getFileTypeValue(queryData?.[0]?.ConvertedFileFormat);
  let fileName = queryData?.[0]?.url?.substring(queryData?.[0]?.url?.lastIndexOf("/") + 1);
  let filePath =
    getBlobUri() +
    "pdfsimpliusers/" +
    queryData?.[0]?.url?.replace(DEFAULT_USER_GUID.replaceAll("-", ""), userId?.replaceAll("-", ""));
  let generalCtx = {
    VisitId: readCookie("visitGuid"),
    VisitorId: readCookie("visitorGuid"),
    ABTestResult: null,
  };
  let docOperationRequest = {
    DocOperationID: CreateUUID(),
    FromFormat: fromFormat,
    ToFormat: toFormat,
    OperationType: getOperationTypeValue("CONVERT"),
    BlobOutputFolder: userId.replaceAll("-", ""),
    ExistingBlobContainer: DEFAULT_USER_GUID.replaceAll("-", ""),
    DocBlobPaths: [filePath],
    FileName: fileName,
    DocId: docProfileResponse?.docInfo?.[0]?.id,
    ResponseFileName: "",
    GeneralContext: generalCtx,
    isScannedFile: false,
    DocCategoryName: CategoryName.TEXT_TO_SPEECH,
  };

  return docOperationRequest;
};
